import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { IconTimesCircle } from "../icons/IconTimesCircle";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonDelete: React.FC<MprcButtonProps> = ({ title, text, color = "error", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonDelete.text;
    const lTitle = title || theme.buttons.ButtonDelete.title;
    return (
        <MprcButton
            {...rest}
            color={color}
            title={lTitle}
            text={lText}
            startIcon={<IconTimesCircle fixedWidth />}
        />
    );
};
